<section>
  <div class="container">
    <div class="row between-lg">
      <div class="col-xs-12 col-lg-6 col-left">
        <app-title [titles]="[titleG()]" class="title" />
        <div [innerHTML]="data().htmlG" class="text"></div>
        @if (data().linkG) {
          <a [href]="data().linkG!.url" class="link">{{ data().linkG!.label }}</a>
        }
      </div>
      <div class="col-xs-12 col-lg-6 .col-lg-offset-1 col-right">
        <app-title [titles]="[titleD()]" class="title" />
        <div [innerHTML]="data().htmlD" class="text"></div>
        @if (data().linkD) {
          <a [href]="data().linkD!.url" class="link">{{ data().linkD!.label }}</a>
        }
      </div>
    </div>
  </div>
</section>
